
// More info: https://spin.atomicobject.com/2018/09/10/javascript-concurrency/

export default class Mutex{

    private mutex: Promise<any> = Promise.resolve();

    lock(): PromiseLike<() => void>{
        // Create an unlock function that doesn't do anything
        let begin: (unlock: ()=>void) => void = unlock => {};


        // Replace the mutex, which will wait for the begin function to resolve, which will never happen with the current begin function
        // Previous mutexes are also waited for
        this.mutex = this.mutex.then(() => {
            return new Promise(begin);
        })

        // When unlock (the function returned below) is executed, the begin function is resolved and our mutex is lifted
        return new Promise(res => {
            begin = res;
        });
    }

    async runCriticalSection<T>(criticalSection: (() => T) | (() => PromiseLike<T>)): Promise<T> {
        const unlock = await this.lock();
        try {
            return await Promise.resolve(criticalSection());
        } finally {
            unlock();
        }
    }

}